import { Link } from "react-router-dom";
import styled from "styled-components";

export const BoxesContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing.lg};
  padding: ${({ theme }) => theme.spacing.lg};
  box-sizing: border-box;

  & > * {
    flex: 0 1 calc(50% - ${({ theme }) => theme.spacing.lg});
  }

  @media (max-width: 1024px) {
    & > * {
      flex: 0 1 calc(50% - ${({ theme }) => theme.spacing.lg});
    }
  }

  @media (max-width: 767px) {
    & > * {
      flex: 0 1 100%;
    }
  }
`;

export const WelcomeBox = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  padding: ${({ theme }) => theme.spacing.lg};
  border-radius: ${({ theme }) => theme.borderRadius.md};
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

export const WelcomeTitle = styled.h1`
  font-size: ${({ theme }) => theme.fontSizes.xl};
  margin: 0 0 ${({ theme }) => theme.spacing.sm} 0;
  color: ${({ theme }) => theme.colors.secondary};
`;

export const WelcomeSubtitle = styled.p`
  font-size: ${({ theme }) => theme.fontSizes.md};
  margin: 0 0 ${({ theme }) => theme.spacing.lg} 0;
  color: ${({ theme }) => theme.colors.secondary};
`;

export const SubscriptionBox = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  padding: ${({ theme }) => theme.spacing.lg};
  border-radius: ${({ theme }) => theme.borderRadius.md};
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
`;

export const SubscriptionTitle = styled.h2`
  font-size: ${({ theme }) => theme.fontSizes.lg};
  margin: 0 0 ${({ theme }) => theme.spacing.sm} 0;
  color: ${({ theme }) => theme.colors.secondary};
`;

export const SubscriptionMessage = styled.p`
  font-size: ${({ theme }) => theme.fontSizes.md};
  margin: 0;
  color: ${({ theme }) => theme.colors.secondary};
`;

export const GetStartedButton = styled(Link)`
  margin-top: ${({ theme }) => theme.spacing.md};
  padding: 0.75rem 1.25rem;
  background-color: ${({ theme }) => theme.colors.primary};
  color: white;
  font-weight: 600;
  text-align: center;
  border-radius: ${({ theme }) => theme.borderRadius.sm};
  text-decoration: none;
  transition: background-color 0.2s ease-in-out;

  &:hover {
    background-color: ${({ theme }) => theme.colors.primaryDark};
  }
`;
